import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/tmp/26d35be0/src/layouts/work.js"

export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={props}
             components={components}>

<MDXTag name="p" components={components}><MDXTag name="img" components={components} parentName="p" props={{"src":"/work/reaktor/1.png","alt":"Reaktor.com screens"}}></MDXTag></MDXTag>
<MDXTag name="p" components={components}>{`Reaktor is one of Finlands biggest technology companies, both an agency and a consultancy, with offices in Helsinki, New York, Tokyo, Amsterdam and Dubai. They provide a wide range of services, from design and technology to business development, with clients like Adidas, Finnair, Nasdaq and HBO to mention a few. Feed executed their new strategy into a digital identity and new website. We created a clean layout style, a subtle color palette and a new fresh illustration style, to emphasize Reaktors role as a nordic player in a global market.`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="img" components={components} parentName="p" props={{"src":"/work/reaktor/2.png","alt":"Reaktor.com frontpage"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/reaktor/3.png","alt":"Reaktor.com mobile screens"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/reaktor/4.png","alt":"Reaktor.com different colored backgrounds on articles"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/reaktor/5.png","alt":"Reaktor.com handheld vs desktop screens"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/reaktor/6.png","alt":"Reaktor.com portraits for blog series"}}></MDXTag>
<MDXTag name="img" components={components} parentName="p" props={{"src":"/work/reaktor/7.png","alt":"Reaktor.comnews page"}}></MDXTag></MDXTag>
           </MDXTag>
  }
}

export const _frontmatter = {};

  